export { default } from './HowTrackingWorks';
export type { HowTrackingWorksProps } from './HowTrackingWorks';
